import './list-layout.scss';


export enum LIST_LAYOUT_SPACING_VARIANT {
    DEFAULT = 'list-layout-spacing-default',
    SMAll = 'list-layout-spacing-small'
}
interface Props {
    children: React.ReactNode,
    spacingVariant?: LIST_LAYOUT_SPACING_VARIANT,
}

const ListLayout: React.FC<Props> = ({ children, spacingVariant = LIST_LAYOUT_SPACING_VARIANT.DEFAULT }) => {
    return (
        <div className={`list-layout-content ${spacingVariant}`}>
            {children}
        </div>
    );
}

export default ListLayout;
